import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

const PlaninarskaUdruga: IModel = {
  title: "Planinarska udruga",
  apiPath: "hps/planinarske-udruge",
  httpUpdateVerb: "put",
  forms : {
   "default": {
    fields: ["prefiks", "naziv", "sjediste", "tip_id", "adresa", "oib", "email", "hps_logotip_url"]
   }
  },
  listViews: {
    "default": {
      fields: ["id", "prefiks", "naziv", "sjediste", "tip_id", "adresa", "oib", "email", "hps_logotip_url", "active"],
      hidden: ["id", "active", "hps_logotip_url"]
    },
    "admin": {
      fields: ["id", "prefiks", "naziv", "sjediste", "tip_id", "adresa", "oib", "email", "cnt_izleti_prijavljeni", "cnt_izleti_odobreni", "hps_logotip_url", "active"],
      hidden: ["id", "active", "hps_logotip_url"]
    }
  },
  fields: [
    coreFields.id,
    coreFields.active,
    {
      title: "Tip planinarske udruge",
      source: "tip_id",
      ttoken: "hps.plan_udruge.tip_id",
      type: "picker",
      items: {
        labels: ["hps.pu_tip.osnovna", "hps.pu_tip.spv"],
        values: [1, 3],
        default: 1,
      },
      validation: {
        required: true,
      },
      translate: true
    },
    commonFields.oib,
    {
      title: "Prefiks",
      source: "prefiks",
      ttoken: "hps.plan_udruge.prefiks",
      type: "text",
    },
    {
      title: "Naziv",
      source: "naziv",
      ttoken: "hps.plan_udruge.naziv",
      type: "text",
      validation: {
        required: true,
      }
    },
    {
      title: "Sjedište",
      source: "sjediste",
      ttoken: "hps.plan_udruge.sjediste",
      type: "text",
      validation: {
        required: true,
      }
    },
    {
      title: "Adresa",
      source: "adresa",
      ttoken: "common.adresa",
      type: "text",
      validation: {
        required: true,
      }
    },
    {
      title: "Email",
      source: "email",
      ttoken: "common.email",
      type: "mail",
      validation: {
        required: true,
      },
      placeholder: "...@hps.hr"
    },
    {
      title: "HPS Logotip URL",
      source: "hps_logotip_url",
      ttoken: "hps.plan_udruge.logotip_url",
      type: "url",
    },
    {
      title: "Broj prijavljenih izleta",
      source: "cnt_izleti_prijavljeni",
      ttoken: "hps.plan_udruge.cnt_izleti_prijavljeni",
      type: "wholenum",
      readonly: true
    },
    {
      title: "Broj odobrenih izleta",
      source: "cnt_izleti_odobreni",
      ttoken: "hps.plan_udruge.cnt_izleti_odobreni",
      type: "wholenum",
      readonly: true
    },
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on
  ]
}

export default PlaninarskaUdruga;
